import { render, staticRenderFns } from "./modalMoverArchivo.vue?vue&type=template&id=c330e234&scoped=true"
import script from "./modalMoverArchivo.vue?vue&type=script&lang=js"
export * from "./modalMoverArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330e234",
  null
  
)

export default component.exports